/* MYOP drag-to-scroll for horizontal carousels ([data-myop-drag]).
   Drag is 1:1 while the pointer is down; on release it projects the flick's
   velocity, finds the nearest snap-aligned card, and eases scrollLeft precisely
   onto it (easeOutCubic). Works for both `start`-aligned (bestsellers) and
   `center`-aligned (hero) carousels — alignment is read from the children. */
(function () {
  var easeOutCubic = function (t) { return 1 - Math.pow(1 - t, 3); };

  // Where a `start`-aligned card should land (scroll-padding, else content padding).
  function startInset(el) {
    var cs = getComputedStyle(el);
    var sp = parseFloat(cs.scrollPaddingLeft);
    if (isNaN(sp)) sp = parseFloat(cs.paddingLeft) || 0;
    return sp;
  }

  // The scrollLeft that snaps the card nearest `pos` into its aligned position.
  function nearestSnap(el, pos) {
    var kids = [];
    for (var i = 0; i < el.children.length; i++) {
      if (el.children[i].nodeType === 1) kids.push(el.children[i]);
    }
    if (!kids.length) return pos;

    var trackRect = el.getBoundingClientRect();
    var align = getComputedStyle(kids[0]).scrollSnapAlign || 'start';
    var isCenter = align.indexOf('center') !== -1;
    var isEnd = !isCenter && align.indexOf('end') !== -1;
    var inset = startInset(el);
    var maxScroll = el.scrollWidth - el.clientWidth;

    var best = pos, bestDist = Infinity;
    for (var j = 0; j < kids.length; j++) {
      var r = kids[j].getBoundingClientRect();
      var childLeft = r.left - trackRect.left + el.scrollLeft; // content-space left
      var target;
      if (isCenter) target = childLeft + r.width / 2 - el.clientWidth / 2;
      else if (isEnd) target = childLeft + r.width - el.clientWidth;
      else target = childLeft - inset;
      if (target < 0) target = 0;
      if (target > maxScroll) target = maxScroll;
      var d = Math.abs(target - pos);
      if (d < bestDist) { bestDist = d; best = target; }
    }
    return best;
  }

  function enable(el) {
    if (el.dataset.myopDragInit === 'true') return;
    el.dataset.myopDragInit = 'true';
    var down = false, startX = 0, startScroll = 0, moved = false;
    var lastX = 0, lastT = 0, velocity = 0, raf = 0; // velocity in px/ms

    function stopAnim() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }

    // Smoothly ease scrollLeft to `target`, then release the grab state so CSS
    // scroll-snap takes back over (we're already parked exactly on a snap point).
    function animateTo(target) {
      stopAnim();
      var from = el.scrollLeft;
      var dist = target - from;
      if (Math.abs(dist) < 1) { el.classList.remove('myop-bs--grabbing'); return; }
      var dur = Math.min(600, Math.max(280, Math.abs(dist) * 0.6)); // distance-scaled
      var t0 = performance.now();
      (function frame(now) {
        var p = Math.min(1, (now - t0) / dur);
        el.scrollLeft = from + dist * easeOutCubic(p);
        if (p < 1) { raf = requestAnimationFrame(frame); }
        else { raf = 0; el.classList.remove('myop-bs--grabbing'); }
      })(t0);
    }

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // native touch scroll is fine
      stopAnim();                            // grabbing mid-glide re-takes control
      down = true; moved = false;
      startX = e.clientX;
      startScroll = el.scrollLeft;
      lastX = e.clientX; lastT = performance.now(); velocity = 0;
      // NOTE: don't capture the pointer here — capturing on a plain click steals
      // it from product links. Capture only once a real drag begins (below).
    });

    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      // 10px threshold so ordinary clicks aren't cancelled as drags.
      if (Math.abs(dx) > 10 && !moved) {
        moved = true;
        el.classList.add('myop-bs--grabbing');
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (moved) {
        el.scrollLeft = startScroll - dx;
        var now = performance.now();
        var dt = now - lastT;
        if (dt > 0) {
          var vx = (e.clientX - lastX) / dt;      // instantaneous px/ms
          velocity = 0.75 * vx + 0.25 * velocity; // low-pass so a jitter can't spike it
          lastX = e.clientX; lastT = now;
        }
      }
    });

    function end(e) {
      if (!down) return;
      down = false;
      try { el.releasePointerCapture(e.pointerId); } catch (err) {}
      if (!moved) { el.classList.remove('myop-bs--grabbing'); return; }
      // Project ~90ms of glide from the release velocity, then ease onto the
      // nearest card. scrollLeft moves opposite the pointer, hence the minus.
      var projected = el.scrollLeft - velocity * 90;
      animateTo(nearestSnap(el, projected));
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('pointerleave', end);

    // Suppress the click that follows a drag so it doesn't trigger a card link.
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-myop-drag]').forEach(enable);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
